import React, { useEffect } from "react";
import "../PopupCommonStyle.css";
import styles from "./Style.module.css";
import { BtnPrimary } from "../../Buttons/BtnPrimary";
// import { BtnLink } from "../../Buttons/BtnLink";
// import { BtnClose } from "../../Buttons/BtnClose/BtnClose";
import { BtnSecondary } from "../../Buttons/BtnSecondary";

export const RemoveVoucherPopup = ({
  active = false,
  onClose,
  onConfirmRemove,
}) => {
  useEffect(() => {
    const body = document.body;
    if (active) {
      body.classList.add("overlay", "overflow-hidden");
    } else {
      body.classList.remove("overlay", "overflow-hidden");
    }

    return () => {
      body.classList.remove("overlay", "overflow-hidden");
    };
  }, [active]);

  return (
    <div
      className={`${styles.removeVoucherPopup} popup ${active ? "show" : ""}`}
    >
      <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">Warning!</h2>
        <p className="titleSub">
          Are you sure you want to remove this voucher from your purchase list?
        </p>
        {/* <BtnClose
        handleClick={onClose}
        customClass="closeBtn circled"
        title="Close"
        iconColor="#ffffff"
        iconSize={16}
        /> */}
      </div>

      <div className={`${styles.footer} popup-footer`}>
        <BtnSecondary
          label="Yes Remove Voucher"
          handleClick={onConfirmRemove}
          title="Yes Remove Voucher"
          customClass="w-100 no-icon"
        />
        <BtnPrimary
          label="Continue Checkout"
          handleClick={onClose}
          customClass="w-100 no-icon"
        />
      </div>
    </div>
  );
};
